import moment from 'moment-timezone';
import extend from 'lodash/extend';
import get from 'lodash/get';
import storage from 'viralstyle-ui/src/storage';

import store from 'store';

export default class PromotionModel {
  constructor(campaignId) {
    this._initDefaults(campaignId);
  }

  _initDefaults(campaignId) {
    this.activated = false;
    this.code = null;
    this.description = null;
    this.discount = null;
    this.discount_type = 'MONEY';
    this.restriction_id = campaignId ? campaignId : storage.get('client-hash');
    this.restriction_type = campaignId ? 'CAMPAIGN' : 'PUBLIC_NAME';
    this.expiration_date = moment().add(1, 'days').format();
  }
};